"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_stripe_js_1 = require("@stripe/react-stripe-js");
require("./cardForm.scss");
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const paymentSlice_1 = require("../../../../redux/slices/paymentSlice");
class CardForm extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            stripeStyles: {
                style: {
                    base: {
                        fontSize: '14px',
                        fontWeight: '400',
                        padding: '0 0 3px 0',
                        '::placeholder': {
                            color: '#808080',
                            fontWeight: '300',
                        },
                    },
                    invalid: {
                        color: "black",
                    }
                },
            },
            brandIcon: 'unknown',
            formValid: null,
        };
        // change event listener for stripe inputs
        this.handleCardElementChange = (elem) => {
            elem.brand && this.setState({ brandIcon: elem.brand });
            this.setState({ formValid: null });
            if (elem.error || elem.empty) {
                this.props.validateStripeElements(false);
            }
            else {
                this.props.validateStripeElements(true);
            }
        };
        // blur event listener for stripe inputs
        this.handleCardElementBlur = () => {
            const isValid = paymentSlice_1.getCardValidatedState();
            this.setState({ formValid: isValid });
        };
        // change event for postal code input
        this.handlePostalCodeChange = (e) => {
            const value = e.target.value;
            if (!this.props.payment.card.postalCodeValid || value === '') {
                this.props.resetCardValidation('postalCodeValid');
            }
            this.setState({ formValid: null });
            this.props.restructurePostalCodeInputValue(e.target.value);
        };
        // blur event for postal code input
        this.handlePostalCodeBlur = (e) => {
            if (!e.target.value) {
                this.props.resetCardValidation('postalCodeValid');
            }
            else {
                this.props.validatePostalCode(e.target.value);
                this.setState({ formValid: paymentSlice_1.getCardValidatedState() });
            }
        };
        // save payment card
        this.saveCard = (e) => {
            const card = this.props.payment.card;
            this.props.elements._elements.forEach(el => {
                if (el._empty) {
                    el._parent.classList.add('StripeElement--invalid');
                    el._parent.classList.remove('StripeElement--empty');
                    this.props.validateStripeElements(false);
                }
            });
            this.props.validatePostalCode(card.postalCode);
            this.setState({ formValid: paymentSlice_1.getCardValidatedState() });
            if (card.isValid && card.postalCodeValid) {
                const cardElement = this.props.elements.getElement(react_stripe_js_1.CardNumberElement);
                this.props.stripe.createToken(cardElement, { address_zip: this.props.payment.card.postalCode })
                    .then(async (res) => {
                    console.log('res', res);
                    if (!res.error) {
                        await this.props.addOrUpdatePayment(res.token);
                        this.resetModal();
                        this.props.toggleModal();
                        window.AppearMe.Widgets.Events.emit('updateUserData', null);
                    }
                })
                    .catch(err => {
                    return false;
                });
            }
        };
        this.resetModal = () => {
            this.setState({ formValid: null, brandIcon: 'unknown' });
            this.props.resetCardValidation(['isValid', 'postalCodeValid']);
            this.props.resetCard();
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
        };
    }
    render() {
        const { payment: payment, card: card } = this.props.payment;
        return (react_1.default.createElement(core_1.Dialog, { id: "card-form-modal", open: this.props.modalOpen, onEnter: () => {
                if (card.postalCode) {
                    this.props.validatePostalCode(card.postalCode);
                }
            }, fullWidth: true, maxWidth: 'xs', onClose: () => {
                this.resetModal();
                this.props.toggleModal();
            } },
            react_1.default.createElement("div", { className: 'v2-modal-title' }, "Card Information"),
            react_1.default.createElement("div", { className: "horizontal-line" }),
            react_1.default.createElement("div", { className: 'v2-modal-content' },
                react_1.default.createElement(react_stripe_js_1.CardNumberElement, { onChange: (e) => this.handleCardElementChange(e), onBlur: () => this.handleCardElementBlur(), options: Object.assign(Object.assign({}, this.state.stripeStyles), { placeholder: 'Card Number' }), className: `card card-number icon icon-${this.state.brandIcon}` }),
                react_1.default.createElement(react_stripe_js_1.CardExpiryElement, { onChange: (e) => this.handleCardElementChange(e), onBlur: () => this.handleCardElementBlur(), options: this.state.stripeStyles, className: 'card card-cvc' }),
                react_1.default.createElement(react_stripe_js_1.CardCvcElement, { onChange: (e) => this.handleCardElementChange(e), onBlur: () => this.handleCardElementBlur(), options: Object.assign(Object.assign({}, this.state.stripeStyles), { placeholder: 'CVC2, CVV2, CID' }), className: 'card card-expiry' }),
                react_1.default.createElement("input", { type: "tel", value: card.postalCode, className: `card card-zipCode ${card.postalCodeValid === false && 'error'}`, onBlur: (e) => this.handlePostalCodeBlur(e), onChange: (e) => this.handlePostalCodeChange(e), placeholder: 'Billing Zip Code' })),
            react_1.default.createElement("div", { className: 'v2-modal-footer' },
                react_1.default.createElement("button", { type: 'button', color: "primary", 
                    //onTouchEnd={() => this.saveCard()}
                    onMouseUp: (e) => setTimeout(() => this.saveCard(e), 50), className: 'v2-btn v2-btn-primary' }, "Save"),
                react_1.default.createElement("button", { type: 'submit', onMouseDown: () => {
                        this.resetModal();
                        this.props.toggleModal();
                    }, className: "v2-btn v2-btn-tertiary" }, "Never Mind")),
            this.state.formValid === false &&
                react_1.default.createElement("span", { className: "v2-validation-error" }, "*Please fill in all required fields.")));
    }
}
const mapStateToProps = (state) => {
    const { payment } = state;
    return {
        payment,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        restructurePostalCodeInputValue: (value) => dispatch(paymentSlice_1.restructurePostalCodeInputValue(value)),
        validatePostalCode: (value) => dispatch(paymentSlice_1.validatePostalCode(value)),
        validateStripeElements: (prop) => dispatch(paymentSlice_1.validateStripeElements(prop)),
        resetCardValidation: (prop) => dispatch(paymentSlice_1.resetCardValidation(prop)),
        resetCard: () => dispatch(paymentSlice_1.resetCard()),
        addOrUpdatePayment: (data) => dispatch(paymentSlice_1.addOrUpdatePayment(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CardForm);
